var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-email-confirm',{ref:"confirm",attrs:{"email":_vm.email},on:{"resend":_vm.onResend,"confirmed":_vm.onConfirmed}})}
var staticRenderFns = []

export { render, staticRenderFns }